import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactGA from 'react-ga';
import { withTranslation } from 'react-i18next';
import applicationSelectors from 'frontend/redux/selectors/application-selectors';
import { bindActionCreators } from 'redux';
import { getGeoData } from 'frontend/redux/actions/application-actions';
import ConsultasClient from '../../../api/consultas';
import { getHostname } from '../../../api/http-client';
import './formulario-consulta.css';
import GeoApi from '../../../api/destinations';
import Commons from '../../../commons/commons';
import ConsultaEstado from './consulta-estado';
import DropDown from '../../../commons/dropdown/dropdown';
import PaquetesClient from '../../../api/paquetes';

class FormularioConsulta extends Component {
  constructor(props) {
    super(props);
    this.state = {
      donde_viajar: '',
      cantidad_dias: 1,
      cantidad_adultos: '',
      cantidad_ninos: 0,
      mes_viaje: '',
      anio_viaje: '',
      nombre: '',
      apellido: '',
      email: '',
      telefono: '',
      comentarios: '',
      consulta_exitosa: false,
      bloquearDestino: false,
      estadoConsulta: 'creando',
      ciudades: [],
      provincias: '',
      provincia: '',
      localidad: '',
      ciudadesDeProvincias: [],
    };
    this.setearEstado = this.setearEstado.bind(this);
    this.enviarConsulta = this.enviarConsulta.bind(this);
    this.autoCompletarCampos = this.autoCompletarCampos.bind(this);
    this.autoCompletarDestino = this.autoCompletarDestino.bind(this);
    this.armarRequestConsulta = this.armarRequestConsulta.bind(this);
    this.onStateChange = this.onStateChange.bind(this);
    this.onCityChange = this.onCityChange.bind(this);
    this.obtenerAgencia = this.obtenerAgencia.bind(this);
    this.generarDatosAsesor = this.generarDatosAsesor.bind(this);
  }

  componentDidMount() {
    this.autoCompletarCampos();
    this.autoCompletarDestino();
    this.props.actions.getGeoData();
  }

  autoCompletarDestino() {
    const url = this.armarUrl();
    const codigo = url.searchParams.get('destino')
      ? url.searchParams.get('destino')
      : window.location.pathname.split('/')[4]
      ? window.location.pathname.split('/')[4]
      : '';
    if (codigo.length === 3) {
      GeoApi.getCityByCode(codigo).then((res) => {
        this.setState({
          donde_viajar: `${res[0]?.codigo} - ${res[0]?.nombre}`,
          bloquearDestino: false,
        });
      });
    }
  }

  autoCompletarCampos() {
    const url = this.armarUrl();
    const habitaciones =
      url.searchParams.get('destino') || window.location.pathname.split('/')[6]
        ? Commons.obtenerDistribucion()
        : null;
    const desde = url.searchParams.get('desde');
    let anioViaje = '';
    let mesViaje = '';
    const cantidadNoches =
      url.searchParams.get('cantidadNoches') === null ? 1 : url.searchParams.get('cantidadNoches');
    const destino = url.searchParams.get('destino')
      ? url.searchParams.get('destino')
      : window.location.pathname.split('/')[4]
      ? window.location.pathname.split('/')[4]
      : '';
    if (desde !== null) {
      anioViaje = desde.split('-')[0];
      mesViaje = desde.split('-')[1];
    }
    this.setState({
      donde_viajar: destino,
      anio_viaje: anioViaje,
      mes_viaje: mesViaje,
      cantidad_adultos: habitaciones !== null ? habitaciones[0].adultos : null,
      cantidad_ninos: habitaciones !== null ? habitaciones[0].menores.length : null,
      bloquearDestino: destino !== '',
      cantidad_dias: cantidadNoches,
    });
  }

  armarUrl = () => {
    const urlString = window.location.href;
    return new URL(urlString);
  };

  setearEstado(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  armarRequestConsulta() {
    const url = this.armarUrl();
    if (url.searchParams.get('type') === 'PaqueteAMedida') {
      return {
        detalle_consulta: {
          donde_viajar: this.state.donde_viajar,
          cantidad_dias: this.state.cantidad_dias,
          cantidad_adultos: this.state.cantidad_adultos,
          cantidad_ninos: this.state.cantidad_ninos,
          mes_viaje: this.state.mes_viaje,
          anio_viaje: this.state.anio_viaje,
          comentarios: this.state.comentarios,
          datos_contacto: {
            email: this.state.email,
            telefono: this.state.telefono,
            nombre: this.state.nombre,
            apellido: this.state.apellido,
          },
          dominio: getHostname(),
          agencia: this.state.datosAsesor
            ? {
                nombre: this.state.datosAsesor.nombre,
                direccion: this.state.datosAsesor.direccion,
                email: this.state.datosAsesor.email,
                telefono: this.state.datosAsesor.telefono,
                horarioAtencion: this.state.datosAsesor.horarioAtencion,
                provinciaId: this.state.datosAsesor.provinciaId,
                localidadId: this.state.datosAsesor.localidadId,
                id: this.state.datosAsesor.aplicacionId,
                activo: this.state.datosAsesor.activo,
                rutaImagen: this.state.datosAsesor.rutaImagen,
                cuit: this.state.datosAsesor.cuit,
                legajo: this.state.datosAsesor.legajo,
                dominio: this.state.datosAsesor.dominio,
                defaultGroup: this.state.datosAsesor.defaultGroup,
                applicationId: this.state.datosAsesor.applicationId,
              }
            : null,
        },
        detalle_producto: {
          producto_id: 2,
          proveedor_producto_id: url.searchParams.get('proveedorId'),
          referencia_producto: url.searchParams.get('referencia'),
          url_detalle_producto: document.referrer,
        },
      };
    }
    return {
      detalle_consulta: {
        donde_viajar: this.state.donde_viajar,
        cantidad_dias: this.state.cantidad_dias,
        cantidad_adultos: this.state.cantidad_adultos,
        cantidad_ninos: this.state.cantidad_ninos,
        mes_viaje: this.state.mes_viaje,
        anio_viaje: this.state.anio_viaje,
        comentarios: this.state.comentarios,
        datos_contacto: {
          email: this.state.email,
          telefono: this.state.telefono,
          nombre: this.state.nombre,
          apellido: this.state.apellido,
        },
        dominio: getHostname(),
        agencia: {
          applicationId: this.props.application.applicationId,
          nombre: this.props.application.nombre,
        },
      },
      detalle_producto: {
        producto_id: 1,
        proveedor_producto_id: 0,
        referencia_producto: '',
        url_detalle_producto: '',
      },
    };
  }

  generarDatosAsesor() {
    return this.state.datosAsesor ? (
      <table>
        <tbody>
          <tr>
            <th>
              {this.state.datosAsesor.nombre} | Email: {this.state.datosAsesor.email}
            </th>
          </tr>
          <tr>
            <td>
              {this.state.datosAsesor.direccion} |{' '}
              {`${this.state.datosAsesor.telefono} ${this.state.datosAsesor.horarioAtencion}`}
            </td>
          </tr>
        </tbody>
      </table>
    ) : (
      <h4>Cargar la provincia y la localidad</h4>
    );
  }

  obtenerAgencia() {
    const { paisId } = this.props;
    const { token, applicationId } = this.props.application;
    const datos = {
      paisId,
      provinciaId: this.state.provincia,
      localidadId: this.state.localidad,
      appId: applicationId,
      tipoAccion: 1, //consulta
    };

    //default value
    const agencia = false;

    if (this.state.provincia !== '' && datos.appId === '1') {
      PaquetesClient.obtenerAgencia(datos, token).then((res) => {
        if (res !== undefined || res.status === 200) {
          this.setState({
            datosAsesor: res.data,
          });
          return res;
        }
        // eslint-disable-next-line no-console
        console.error('[LOG] ERROR OBTENIENDO AGENCIA');
      });
    }
    return agencia;
  }

  onStateChange(provincia) {
    const ciudadesObtener = this.props.localities;
    const ciudades = ciudadesObtener.filter(
      (ciudad) => parseInt(ciudad.provinciaId) === parseInt(provincia),
    );

    this.setState({
      ciudadesDeProvincias: ciudades,
      provincia,
    });
  }

  onCityChange(value) {
    this.setState(
      {
        localidad: value,
      },
      () => {
        if (this.props.application.applicationId === '1') {
          this.obtenerAgencia();
        }
      },
    );
  }

  enviarConsulta(event) {
    event.preventDefault();
    const { token } = this.props.application;
    const data = this.armarRequestConsulta();
    this.setState({ estadoConsulta: 'enviando' });
    ConsultasClient.consultar(data, token).then((res) => {
      ReactGA.event({
        category: 'Accion',
        action: 'Consultar',
        label: 'Paquetes',
        nonInteraction: true,
      });
      if (res.status === 200) {
        this.setState({
          consulta_exitosa: true,
          estadoConsulta: 'enviado',
        });
      } else {
        this.setState({
          consulta_exitosa: true,
          estadoConsulta: 'error',
        });
      }
    });
  }

  render() {
    const { t } = this.props;
    const armarMeses = () => {
      const lang = t('requestForm.monthLang');
      const listaMeses = [];
      let numeroMes;
      for (let indice = 1; indice <= 12; indice++) {
        const nombreMes = moment(indice, 'MM').locale(lang).format('MMMM');
        numeroMes = indice < 10 ? `0${indice}` : indice;
        listaMeses.push(<option value={numeroMes}>{nombreMes}</option>);
      }
      return listaMeses;
    };

    const armarAnios = () => {
      const anioActual = moment().format('YYYY');
      const listaAnios = [];
      for (let indice = anioActual; indice <= Number(anioActual) + 1; indice++) {
        listaAnios.push(<option value={indice}>{indice}</option>);
      }
      return listaAnios;
    };
    const asignadorAgencia = () => {
      if (parseInt(this.props.applicationType) === 1) {
        return (
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-3">
              <div className="form-group">
                <div className="clearfix" />
                <label
                  htmlFor="provincia-facturacion"
                  className="block text-gray-700 text-sm font-bold mb-2"
                >
                  {t('requestForm.state')}
                </label>
                <DropDown
                  onChange={this.onStateChange}
                  data={this.props.provinces}
                  data-name="provincia"
                  id="provincia-facturacion"
                  name="provincia-facturacion"
                  className="block w-full"
                  required
                />
              </div>
            </div>
            <div className="col-span-12 md:col-span-3">
              <div className="form-group">
                <span className="block text-gray-700 text-sm font-bold mb-2">
                  {t('requestForm.city')}
                </span>
                <DropDown
                  onChange={this.onCityChange}
                  data={this.state.ciudadesDeProvincias}
                  data-name="localidad"
                  id="localidad-facturacion"
                  name="localidad-facturacion"
                  className="block w-full"
                  required
                />
              </div>
            </div>
            <div className="col-span-12 md:col-span-6">
              <span className="block text-gray-700 text-sm font-bold mb-2">
                {t('requestForm.agencyDerivation')}
              </span>
              {this.generarDatosAsesor()}
            </div>
          </div>
        );
      }
      return '';
    };

    const formulario = (
      <div className="form-consult panel panel-default custom consulta" style={{ paddingTop: 0 }}>
        <div className="panel panel-default buscador sin-paquetes p-4 mb-5 bg-white">
          {t('requestForm.soldOut')}
        </div>
        <form onSubmit={this.enviarConsulta}>
          <h2 className="text-lg font-bold text-red-800 mb-2">{t('requestForm.requestTitle')}</h2>
          {/* <div className='grid grid-cols-12 gap-4'>
            <div className='col-span-12'>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>
                  {t('requestForm.destination')}
                </span>
                <input
                  id='donde-viajar'
                  onChange={this.setearEstado}
                  value={this.state.donde_viajar}
                  name='donde_viajar'
                  type='text'
                  placeholder='Ingresa el destino al que deseas viajar'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
            </div>
            <div className='col-span-12 md:col-span-2'>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('requestForm.daysAmount')}</span>
                <input
                  id='cantidad-dias'
                  onChange={this.setearEstado}
                  value={this.state.cantidad_dias}
                  name='cantidad_dias'
                  type='number'
                  min='0'
                  placeholder='Ingresa la cantidad de días'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                  required
                />
              </div>
            </div>
            <div className='col-span-12 md:col-span-2'>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('requestForm.adultsAmount')}</span>
                <input
                  id='cantidad-adultos'
                  onChange={this.setearEstado}
                  value={this.state.cantidad_adultos}
                  name='cantidad_adultos'
                  type='number'
                  min='0'
                  placeholder='Ingresa la cantidad de adultos'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                />
              </div>
            </div>
            <div className='col-span-12 md:col-span-2'>
              <div className='form-group'>
                <div className='clearfix' />
                <span
                  className='block text-gray-700 text-sm font-bold mb-2'
                >
                  {t('requestForm.childrenAmount')}
                </span>
                <input
                  id='cantidad-ninos'
                  onChange={this.setearEstado}
                  value={this.state.cantidad_ninos}
                  name='cantidad_ninos'
                  type='number'
                  min='0'
                  placeholder='Ingresa la cantidad de niños'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                />
              </div>
            </div>
            <div className='col-span-12 md:col-span-3'>
              <span className='block text-gray-700 text-sm font-bold mb-2'>
                {t('requestForm.month')}
              </span>
              <select
                onChange={this.setearEstado}
                value={this.state.mes_viaje}
                name='mes_viaje'
                id='month-travel'
                className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                required
                style={{ textTransform: 'capitalize' }}
              >
                <option value=''>
                  {t('requestForm.selectMonth')}
                </option>
                {armarMeses()}

              </select>
            </div>
            <div className='col-span-12 md:col-span-3'>
              <span className='block text-gray-700 text-sm font-bold mb-2'>
                {t('requestForm.year')}
              </span>
              <select
                id='year-travel'
                onChange={this.setearEstado}
                value={this.state.anio_viaje}
                name='anio_viaje'
                className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                required
              >
                <option value=''>
                  {t('requestForm.selectYear')}
                </option>
                {armarAnios()}
              </select>
            </div>
          </div>
          <br /> */}
          <h2 className="text-lg font-bold text-red-800 mb-2">
            {t('requestForm.personalDataTitle')}
          </h2>
          <div className="grid grid-cols-12 gap-4 mb-4">
            <div className="col-span-12 md:col-span-3">
              <div className="form-group">
                <div className="clearfix" />
                <span className="block text-gray-700 text-sm font-bold mb-2">
                  {t('requestForm.name')} (*)
                </span>
                <input
                  id="nombre"
                  onChange={this.setearEstado}
                  value={this.state.nombre}
                  name="nombre"
                  type="text"
                  className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                  required
                />
              </div>
            </div>
            <div className="col-span-12 md:col-span-3">
              <div className="form-group">
                <span className="block text-gray-700 text-sm font-bold mb-2">
                  {t('requestForm.lastName')}
                </span>
                <input
                  id="apellido"
                  onChange={this.setearEstado}
                  value={this.state.apellido}
                  name="apellido"
                  type="text"
                  className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                />
              </div>
            </div>
            <div className="col-span-12 md:col-span-3">
              <div className="form-group">
                <span className="block text-gray-700 text-sm font-bold mb-2">E-mail(*)</span>
                <input
                  id="email"
                  onChange={this.setearEstado}
                  value={this.state.email}
                  name="email"
                  type="email"
                  className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                  required
                />
              </div>
            </div>
            <div className="col-span-12 md:col-span-3">
              <div className="form-group">
                <span className="block text-gray-700 text-sm font-bold mb-2">
                  {t('requestForm.phone')}
                </span>
                <input
                  id="telefono"
                  onChange={this.setearEstado}
                  value={this.state.telefono}
                  name="telefono"
                  type="number"
                  className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                />
              </div>
            </div>
          </div>
          {asignadorAgencia()}
          <div className="my-2">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="comentarios">
              {t('requestForm.comments')}
              (*)
            </label>
            <textarea
              id="comentarios"
              onChange={this.setearEstado}
              value={this.state.comentarios}
              name="comentarios"
              className="h-36 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
              rows="5"
              placeholder={t('requestForm.commentsPlaceholder')}
              required
            />
          </div>
          <div className="flex">
            <button
              type="submit"
              className="ml-auto border border-red-800 text-red-800 transition duration-300 hover:bg-red-100 font-semibold py-2 px-8 rounded focus:outline-none"
            >
              {t('requestForm.send')}
            </button>
          </div>
        </form>
      </div>
    );
    switch (this.state.estadoConsulta) {
      case 'creando':
        return formulario;
      case 'enviando':
        return <ConsultaEstado>{t('requestForm.sending')} ...</ConsultaEstado>;
      case 'enviado':
        return <ConsultaEstado>{t('requestForm.confirm')}</ConsultaEstado>;
      case 'error':
        return <ConsultaEstado>{t('requestForm.error')}</ConsultaEstado>;
      default:
        return formulario;
    }
  }
}

const mapStateToProps = (state) => ({
  application: state.applicationState,
  paisId: state.applicationState.paisId,
  applicationType: parseInt(state.applicationState.tipoAplicacionId),
  provinces: applicationSelectors.cities(state),
  localities: applicationSelectors.localities(state),
});

const mapDispatchToProps = function (dispatch) {
  return {
    actions: bindActionCreators({ getGeoData }, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(['translations'])(FormularioConsulta));
